
import { RootEntities } from "@eqengage/system-enums";
import i18n from "i18next";
import backend from "i18next-xhr-backend";
import {initReactI18next} from "react-i18next";
import { getCachedUserToken } from "src/userToken";

export const initI18n = (constantTextApiUrl: string) => {
i18n
    .use(backend)
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        fallbackLng: 'en-us',
        lowerCaseLng: true, //setting en-US to en-us
        debug: false,
        parseMissingKeyHandler: (key) => {
            console.warn("Missing translation key:", key);
            return key
        },
        // Texts for the login form errors. Setting resources also stops i18next from
        // calling the lingual service at start (no token yet). Lingual texts are
        // loaded after login in GlobalContext.loadDca via reloadResources().
        resources: {
            'en-us': {
                'engage-ui': {
                    'eq-eg-client-error-invalid-email': 'Invalid email',
                    'eq-eg-client-error-invalid-password-length': 'The password length should be at least 8 characters',
                    'eq-eg-client-error-invalid-password-special-character': 'Password should include at least one special character',
                    'eq-eg-client-error-invalid-password-upper-case': 'Password should include at least one upper-case character',
                    'eq-eg-client-error-invalid-password-lower-case': 'Password should include at least one lower-case character',
                    'eq-eg-client-error-invalid-password-no-spaces-allowed': 'Password should not contain spaces',
                },
            },
        },
        backend: {
            allowMultiLoading: false,
            loadPath: (langs: string[], namespaces: string[]) => {
                const clientCode = window.sessionStorage.getItem('clientCode') ?? RootEntities._Client//RootEntities._Client
                const [lang] = langs;
                const [namespace] = namespaces;
                return `${constantTextApiUrl}/texts/${lang}/${namespace}?clientCode=${clientCode}`;
            },
            customHeaders: () => {
                const token = getCachedUserToken();
                return token ? { Authorization: `Bearer ${token}` } : {};
            },
        },
        ns: ['engage-ui', 'engage-error', 'engage-payment-portal', 'engage-offer-group'],
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
        load: 'currentOnly',
    });
  }